import coreFacilityImg from "../../assets/eventsImg/globalProtCoreFacilityDay.png";
import generic from "../../assets/eventsImg/generic.png";

export const newsItems = [
	{
		id: "core-facility-day-2026",
		slug: "core-facility-day",
		category: "EVENT",
		title: "Global Proteomics and Proteogenomics CORE FACILITY Open Day",
		heroImageUrl: coreFacilityImg,

		event: {
		dateLabel: "16-02-2026",
		timeLabel: "9:30 am - 11:30 am",
		locationLabel: "Campus Solna SciLifeLab, Tomtebodavägen 23A",
		},

		excerpt:
		"Looking to uncover disease mechanisms, identify new biomarkers, or gain deeper insight into complex biological systems? The Global Proteomics and Proteogenomics Core Facility at SciLifeLab warmly invites you to an Open Day.",

		content: {
			paragraphs: [
				"Looking to uncover disease mechanisms, identify new biomarkers, or gain deeper insight into complex biological systems? The Global Proteomics and Proteogenomics Core Facility at SciLifeLab warmly invites you to an Open Day.",
				"Proteomics can empower both medical and biological research by revealing functional protein changes, pathway dynamics, and molecular interactions that other omics cannot capture. Explore the potential of proteomics and enjoy a complimentary breakfast before the event starts.",
				"Welcome to the Open Day of the Proteomics Core Facility, a dedicated event showcasing the analytical services and technologies available for proteomic research.",
			],
			bulletsTitle: "Presentations during the event will cover:",
			bullets: [
				"the range of analyses offered by the facility",
				"data formats and output options",
				"pricing information and service access procedures",
				"examples of applications and case studies",
			],
			paragraphsAfter: [
				"After the presentations, participants will have the opportunity to meet technical and scientific staff, tour the facility, and discuss potential collaborations or research projects.",
				"Attendance is free, but registration is required. Please register by February 8th to help us plan the event effectively.",
			],
			links: [
				{
					label: "Register for the Open Day.",
					href: "https://forms.office.com/Pages/ResponsePage.aspx?id=8e73v0vPMk--PaHdoEPAXcqblcEktWVKtzFuYHLaccpURUFMN01USENLUlMxS0JJOExXUkEyVFlIWS4u",
				},
			],
		},
	},

	{
		id: "preprint-ffpe-lung",
		slug: "new-preprint-ffpe-lung-biopsies",
		category: "PUBLICATION",
		title: "NEW PREPRINT - PROTEOMICS OF SINGLE-SLIDE FFPE LUNG CANCER BIOPSIES",
		heroImageUrl: generic,

		excerpt:
		"Proteomics profiling from a single-slide FFPE lung cancer biopsy is finally possible. Orre's group shows great analytical depth from a single 4µm FFPE section of late-stage lung cancer biopsies—opening new possibilities for precision medicine.",

		content: {
			paragraphs: [
				"Proteomics Profiling from single-slide FFPE lung cancer biopsies finally possible! Check out Orre's group preprint showing great proteome analytical depth from just a single FFPE section (4µm!) of late-stage lung cancer biopsies.",
				"This opens up completely new possibilities to improve precision medicine in the cancer patients that needs it the most. 🎯",
				"Now we need to apply these methods to additional lung cancer cohorts to build more knowledge and to find new biomarkers and drug targets. Congratulations to the great work by their team!",
			],
			links: [{ label: "Read the preprint link", href: "https://www.biorxiv.org/content/10.64898/2026.01.20.700495v1" }],
		},
	},

	{
		id: "scilifelab-pulse",
		slug: "scilifelab-pulse-postdoc-program",
		category: "OPPORTUNITY",
		title: "SciLifeLab PULSE: Postdoc program for Future Leaders in Life Science Academia and Industry",
		heroImageUrl: generic,

		excerpt:
		"Join SciLifeLab PULSE (Program for future leaders in Life Science) to move your research career forward. Application period: Dec 15, 2025 - Mar 16, 2026 (MSCA eligibility).",

		content: {
			paragraphs: [
				"Join SciLifeLab PULSE (Program for future leaders in Life Science) to move your research career forward.",
				"Application Period: open between December 15, 2025 and March 16, 2026, and welcomes candidates of all nationalities under MSCA eligibility criteria.",
			],
			sections: [
				{
				heading: "About the Programme",
				bullets: [
					"Fellowship: each participant will benefit from a 36-month postdoctoral training.",
					"Two tracks to align with your goals: choose between the academic or the entrepreneurial path.",
					"Global Collaboration: opportunities for secondments at 29 renowned research institutions, infrastructures, and industry partners across Europe and beyond.",
					"Host Universities: collaborate with one of 11 leading Swedish universities.",
				],
				},
				{
				heading: "What You Get",
				bullets: [
					"Transferable Skills: e.g. Open science, FAIR, communication, entrepreneurship and leadership training.",
					"Technology and methodology skills: research methodology and technology training according to an individually designed career development plan.",
					"Networking Opportunities: build lasting relationships through secondments at any of the PULSE partners.",
					"Leadership Development: become one of the 48 future leaders equipped to move forward towards their goals within molecular life sciences.",
					"Competitive salary and benefits, including access to the Swedish social security system, to support work-life balance.",
				],
				},
			],
			links: [{ label: "Visit SciLifeLab PULSE for more details.", href: "https://www.scilifelab.se/research/pulse/" }],
		},
	},
];
